/* Tysk katalog for locale-closing-purchases-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'route.arsavslutning-kjop': 'Einkäufe und Belege',
  'clo.purchases.title': 'Einkäufe und Belege',
  'clo.purchases.year': 'Einkommensjahr {{year}}',
  'clo.purchases.subtitle': 'Verfolge Einkäufe und Belege für das Einkommensjahr {{year}} nach.',
  'clo.purchases.pending': '{{count}} Einkäufe oder Belege müssen bearbeitet werden, bevor die Einkaufsprüfung für {{year}} bereit ist.',
  'clo.purchases.ready': 'Keine unbearbeiteten Einkäufe oder fehlenden Einkaufsbelege für {{year}} gefunden.',
  'clo.purchases.unsupported': 'Die Einkaufsprüfung wird für dieses Land, dieses Regelwerk oder dieses Jahr nicht unterstützt.',
  'clo.purchases.purchaseIssues': 'Einkäufe, die nachverfolgt werden müssen',
  'clo.purchases.missingTitle': 'Transaktionen ohne Beleg ({{count}})',
  'clo.purchases.missingSummary': 'Füge die Dokumentation hinzu, die zu jeder Transaktion gehört.',
  'clo.purchases.reviewMissing': 'Belege anzeigen und hinzufügen',
  'clo.purchases.documentsModalTitle': 'Fehlende Belege',
  'clo.purchases.missingHelp': 'Ziehe einen Beleg auf die richtige Zeile oder lade ihn hoch.',
  'clo.purchases.missingDateAction': 'Gültiges Datum fehlt – öffne die Transaktion, um das Jahr zu wählen',
  'clo.purchases.upload': 'Beleg hochladen',
  'clo.purchases.uploading': 'Wird hochgeladen …',
  'clo.purchases.uploaded': 'Der Beleg wurde hinzugefügt.',
  'clo.purchases.uploadLater': 'Belege später hochladen',
  'clo.purchases.uploadError': 'Der Beleg konnte nicht hochgeladen werden.',
  'clo.purchases.noMissingDocumentation': 'Alle Transaktionen haben einen Beleg.',
  'clo.purchases.deferredHelp': 'Belege werden später hochgeladen. Sie können die Prüfung fortsetzen, müssen die Belege aber vor dem Jahresabschluss hinzufügen.',
  'clo.purchases.inboxSideHelp': 'Hier liegen die Belege, die noch nicht gebucht sind.',
  'clo.purchases.inboxInteractionHint': 'Öffne einen Beleg, um ihn zu prüfen.',
  'clo.purchases.continueWithoutInbox': 'Ohne Bearbeitung fortfahren',
  'clo.purchases.continueConfirmTitle': 'Nicht relevant für den Jahresabschluss?',
  'clo.purchases.continueConfirmText': 'Bestätige, dass die {{count}} unbearbeiteten Belege für die Einkaufsprüfung {{year}} nicht relevant sind. Sie bleiben im Posteingang, blockieren diesen Jahresabschluss aber nicht.',
  'clo.purchases.inboxExcluded': 'Die Belege wurden als nicht relevant für diesen Jahresabschluss bewertet.',
  'clo.purchases.excludeError': 'Die Bewertung konnte nicht gespeichert werden.',
  'clo.purchases.noPurchaseIssues': 'Keine offenen Abweichungen bei erfassten Einkäufen.',
  'clo.purchases.missingDocumentation': 'Beleg fehlt',
  'clo.purchases.lostDocumentation': 'Beleg als verloren gemeldet. Die Abweichung ist protokolliert, aber der Einkauf benötigt weiterhin eine Dokumentation.',
  'clo.purchases.draft': 'Einkaufsentwurf muss fertig bearbeitet werden',
  'clo.purchases.undated': 'Gültiges Datum fehlt. Kläre, zu welchem Jahr der Posten gehört.',
  'clo.purchases.unknownDate': 'Gültiges Datum fehlt',
  'clo.purchases.inboxTitle': 'Unbearbeitete Belege ({{count}})',
  'clo.purchases.inboxScope': 'Bearbeite die Belege, die zu {{year}} gehören, oder fahre fort, wenn sie für diesen Jahresabschluss nicht relevant sind.',
  'clo.purchases.scopeHelp': 'Eine unbezahlte Lieferantenrechnung kann vollständig gebucht sein. Zahlung, MwSt.-Abstimmung und Periodenabgrenzung werden in eigenen Schritten geprüft. Bereit bedeutet hier, dass die erfassten Einkäufe und der Posteingang diese Prüfung bestanden haben.',
  'clo.purchases.openPurchase': 'Einkauf öffnen',
  'clo.purchases.openInbox': 'Belege im Posteingang bearbeiten',
  'clo.purchases.back': 'Zurück zur Einkaufsprüfung',
  'clo.purchases.backToClosing': 'Zurück zum Jahresabschluss',
  'clo.purchases.loadError': 'Der Einkaufsbereich konnte nicht geöffnet werden.',
  'clo.payables.title': 'Lieferantenverbindlichkeiten',
  'clo.payables.itemsTitle': 'Offene Lieferantenposten zum 31.12.{{year}}',
  'clo.payables.itemsHelp': 'Lieferantenrechnungen, die zum Jahreswechsel offen waren, auch aus früheren Jahren. Spätere Zahlungen werden separat angezeigt und ändern den Saldo zum 31.12. nicht.',
  'clo.payables.supplier': 'Lieferant und Dokument',
  'clo.payables.date': 'Dokumentdatum und Fälligkeit',
  'clo.payables.openAmount': 'Offen zum Jahreswechsel',
  'clo.payables.followUp': 'Nachverfolgung',
  'clo.payables.paidAfterAmount': 'Nach dem Jahreswechsel bezahlt: {{amount}}',
  'clo.payables.balanceTitle': 'Abstimmung mit dem Hauptbuch',
  'clo.payables.assessmentTitle': 'Bewertung und Freigabe',
  'clo.payables.reviewHelp': 'Bewerte die Posten über die Kontrollkästchen in der Tabelle, bevor du die Prüfung freigibst.',
  'clo.payables.saveAssessment': 'Bewertung speichern',
  'clo.payables.help': 'Hauptbuch und offene Lieferantenposten zum 31.12.{{year}} werden automatisch verglichen.',
  'clo.payables.ledger': 'Hauptbuch',
  'clo.payables.subledger': 'Nebenbuch',
  'clo.payables.difference': 'Differenz',
  'clo.payables.needsReview': 'Zu bewerten ({{count}})',
  'clo.payables.allOpen': 'Alle offenen Posten ({{count}})',
  'clo.payables.due': 'Fällig {{date}}',
  'clo.payables.noDueDate': 'Kein Fälligkeitsdatum',
  'clo.payables.open': 'Transaktion öffnen',
  'clo.payables.reviewed': 'Bewertet',
  'clo.payables.noRows': 'Keine offenen Posten in dieser Auswahl.',
  'clo.payables.cutOffQuestion': 'Gibt es Waren oder Dienstleistungen, die vor dem 31.12.{{year}} eingegangen sind und noch nicht gebucht wurden?',
  'clo.payables.cutOffHelp': 'Das ist der Teil, den Plumme nicht allein anhand der gebuchten Daten beurteilen kann.',
  'clo.payables.cutOffNo': 'Nein, alles ist gebucht',
  'clo.payables.cutOffYes': 'Ja, etwas fehlt',
  'clo.payables.unrecordedHelp': 'Erfasse die fehlenden Einkäufe, bevor die Prüfung abgeschlossen werden kann.',
  'clo.payables.complete': 'Prüfung freigeben',
  'clo.payables.saved': 'Die Lieferantenverbindlichkeiten sind geprüft.',
  'clo.payables.saveError': 'Die Prüfung konnte nicht gespeichert werden.',
  'clo.payables.reason.reconciled': 'Abgestimmt',
  'clo.payables.reason.notApplicable': 'Keine Lieferantenverbindlichkeiten zum Jahresende.',
  'clo.payables.reason.unsupported': 'Die Prüfung wird für dieses Land, dieses Regelwerk oder dieses Jahr nicht unterstützt.',
  'clo.payables.reason.stale': 'Die Zahlengrundlage hat sich geändert. Prüfe die Posten erneut.',
  'clo.payables.reason.ledgerDifference': 'Hauptbuch und Nebenbuch stimmen nicht überein.',
  'clo.payables.reason.missingDocument': 'Bei einem offenen Lieferantenposten fehlt der Beleg.',
  'clo.payables.reason.invalidDate': 'Eine Lieferantenrechnung hat kein gültiges Datum.',
  'clo.payables.reason.basisReviewRequired': 'Die Kontengrundlage muss geprüft werden.',
  'clo.payables.reason.cutOffRequired': 'Eine Angabe muss geklärt werden.',
  'clo.payables.reason.unrecordedItems': 'Fehlende Einkäufe müssen gebucht werden.',
  'clo.payables.reason.exceptionsRequired': 'Bewerte die markierten Posten.',
  'clo.payables.reason.reviewRequired': 'Die Prüfung muss abgeschlossen werden.',
  'clo.payables.issue.ledgerDifference': 'Die Differenz muss in der Buchhaltung korrigiert werden, bevor die Prüfung abgeschlossen werden kann.',
  'clo.payables.issue.missingDocument': 'Füge Belege zu offenen Posten hinzu, denen die Dokumentation fehlt.',
  'clo.payables.issue.invalidDate': 'Öffne die Lieferantenrechnung und erfasse das richtige Rechnungsdatum.',
  'clo.payables.issue.basisReviewRequired': 'Plumme kann für dieses Unternehmen keine sichere Kontengrundlage berechnen.',
  'clo.payables.flag.old': 'Älter als 90 Tage',
  'clo.payables.flag.overdue': 'Seit über 30 Tagen fällig',
  'clo.payables.flag.negative': 'Negativer Saldo',
  'clo.payables.flag.duplicate': 'Mögliches Duplikat',
  'clo.payables.flag.currency': 'Fremdwährungsposten',
  'clo.payables.flag.missingDocument': 'Beleg fehlt',
  'clo.payables.flag.paidAfter': 'Nach Jahresende bezahlt',
});
